import {RecordForm} from '../forms/RecordForm';


import {useRegistrar} from '../hooks/useRegistrar';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useRegistrar();

    return (
        <FormPageLayout
            title='Add Registrar'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
